import { render, staticRenderFns } from "./OrdersByStates.vue?vue&type=template&id=2ed32ae6&scoped=true&"
import script from "./OrdersByStates.vue?vue&type=script&lang=js&"
export * from "./OrdersByStates.vue?vue&type=script&lang=js&"
import style0 from "./OrdersByStates.vue?vue&type=style&index=0&id=2ed32ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed32ae6",
  null
  
)

export default component.exports